import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type AdminBadgeRole = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

@Component({
  selector: 'admin-badge',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
})
export class AdminBadgeComponent {
  @Input({ required: true }) label!: string;
  @Input() role: AdminBadgeRole = 'neutral';

  /**
   * What the badge means, for a reader who cannot see the colour — "Status: Active".
   * Left unset, the badge is announced by its visible label alone.
   */
  @Input() ariaLabel: string | null = null;

  get roleClass(): string {
    return `admin-badge--${this.role}`;
  }
}
